import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка заявок
    async getTasks(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams({
        ...data,
        sortBy: data.sortBy && data.sortBy.map(i => i === 'location_rate' ? 'payment_first' : i)
      });


      if (data.start_date) {
        const serverDate = this.getDateToServer(data.start_date).toISOString();
        params.set("start_date", serverDate);
      }

      if (data.end_date) {
        const serverDate = this.getDateToServer(data.end_date).toISOString();
        params.set("end_date", serverDate);
      }

      if (data.status_id > 0) {
        params.set("status_id", data.status_id);
      }

      if (data.work_type_id > 0) {
        params.set("work_type_id", data.work_type_id);
      }

      if (data.group_id > 0) {
        params.set("group_id", data.group_id);
      }

       if (data.executor > 0) {
         params.set("executor", data.executor);
       }

      if (data.paid) {
        params.set("paid", data.paid);
      }

      if (data.paid_workers > 0) {
        params.set("paid_workers", data.paid_workers);
      }

      if (data.include_tw) {
        params.set("include_tw", "1");
      }

      return await this.get(`tasks?${params.toString()}${data.locations}${data.users}${data.work_type_ids}${sorting}`);
    },
    // Получение завки по id
    async getTaskById(id) {
      return await this.get(`tasks/id/${id}`);
    },
    // Создание завки
    async postTask(data) {
      return await this.post('tasks', data);
    },
    // Пакетное создание заявок
    async postTasksBatch(data) {
      return await this.post('tasks/batch', data);
    },
    // Изменение завки
    async putTask(data) {
      return await this.put(`tasks/${data.id}`, data);
    },
    // Удаление заявки
    async deleteTask(data) {
      return await this.delete(`tasks/${data.id}`, null);
    },
    // Получение списка статусов заявки
    async getTaskStatuses() {
      return await this.get('taskstatus');
    },
    // Обновление статусов заявок
    async postTaskUpdateStatus(data) {
      const ids = data.task_ids.map(function (item) {
        return "&task_ids[]=" + item;
      });
      const taskIds = ids.join('').substring(1);

      return await this.post(`tasks/update_status?status_id=${data.status_id}&${taskIds}`, data);
    },

    // Получение списка файлов зявки
    async getTaskFilesByTaskId(taskId) {
      return await this.get(`task_files/task_id/${taskId}`);
    },
    // Загрузка файла заявки
    async getTaskFile(id) {
      return await this.getFile(`task_files/id/${id}`);
    },
    // Отправка файла заявки
    async postTaskFile(id, formData) {
      return await this.post(`task_files/${id}`, formData);
    },
    // Удаление файла заявки
    async deleteTaskFile(id) {
      return await this.delete(`task_files/${id}`, null);
    },

    // Получение списка заявок в выставлении счёта
    async getInvoiceTasks(data) {
      let params = this.makeSearchParams(data);

      if (data.customer_id > 0) {
        params.set("customer", data.customer_id);
      }

      if (data.paid === 0 || data.paid === 1) {
        params.set("paid", data.paid);
      } else {
        params.delete("paid");
      }

      if (data.executor > 0) {
        params.set("executor", data.executor);
      }

      if (data.town > 0) {
        params.set("town", data.town);
      }

      if (data.paid_workers > 0) {
        params.set("paid_workers", data.paid_workers);
      }

      if (data.status_id > 0) {
        params.set("status_id", data.status_id);
      }

      if (data.startDate && data.startDate !== "") {
        const serverDate = this.formatServerDate(this.getDateToServer(data.startDate));
        params.set("start_date", serverDate);
      }

      if (data.endDate && data.endDate !== "") {
        const serverDate = this.formatServerDate(this.getDateToServer(data.endDate));
        params.set("end_date", serverDate);
      }

      return await this.get(`tasks?${params.toString()}${data.locations}`);
    },
    // Получение табеля по заявке
    async postTaskTimesheetFile(data) {
      let params = this.makeSearchParams(data);

      if (data.status_id > 0) {
        params.set("status_id", data.status_id);
      }

      if (data.paid_workers > 0) {
        params.set("paid_workers", data.paid_workers);
      }

      if (this.dateValidation(data.start_date)) {
        let start_date = this.getDateToServer(data.start_date);
        start_date.setHours(0, 0, 0, 0);
        params.set("start_date", this.formatServerDate(start_date));
      }

      if (this.dateValidation(data.end_date)) {
        let end_date = this.getDateToServer(data.end_date);
        end_date.setHours(0, 0, 0, 0);
        params.set("end_date", this.formatServerDate(end_date));
      }

      const formData =  {
        task_ids: data.task_ids
      }

      return await this.postFile(`tasks/timesheet?${params.toString()}${data.locations}${data.users}`, formData)
    }
  }
}



// WEBPACK FOOTER //
// ./src/network/tasks.js